/** Use the previous browser page when available, including a form's last page after completion. */
export function goBackOrFallback(back: () => void, fallback: () => void): void {
    if (window.history.length > 1) {
        back();
    } else {
        fallback();
    }
}
